import { HEADER_MODIFY_TABLE_CONTENT_PROPERTY } from '@/corePagesModule/BaseTableContent/constants';
import { TableContentHeader } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';

export const DELETION_BUSINESS_TABLE_CONTENT_PROPERTIES: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    // TODO: 展開機能が無いので、一旦コメントアウト
    // {
    //   key: 'expansion',
    //   isVariableWidth: false,
    //   isNarrowable: false,
    //   isEditable: false,
    //   sortOption: { isSortable: false, isAsc: true },
    //   headerWidth: 32,
    //   propertyPath: { paths: ['expansion'], propertyType: 'string' },
    // },
    {
      key: 'businessId',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessId'], propertyType: 'string' },
    },
    {
      key: 'warehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'businessNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumber'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'unit',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['unit'], propertyType: 'string' },
    },
    {
      key: 'customerNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['customerNumber'], propertyType: 'string' },
    },
    {
      key: 'customerName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['customerName'], propertyType: 'string' },
    },
    {
      key: 'salesDestinationNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['salesDestinationNumber'], propertyType: 'string' },
    },
    {
      key: 'salesDestinationName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['salesDestinationName'], propertyType: 'string' },
    },
    {
      key: 'manufacturer',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['manufacturer'], propertyType: 'string' },
    },
    {
      key: 'endUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['endUser'], propertyType: 'string' },
    },
    {
      key: 'supplierForecastResponsibleUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['responsibleUserName', 'supplierForecast'], propertyType: 'string' },
    },
    {
      key: 'customerForecastResponsibleUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['responsibleUserName', 'customerForecast'], propertyType: 'string' },
    },
    {
      key: 'businessUpdateAt',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessUpdateAt'], propertyType: 'string' },
    },
    HEADER_MODIFY_TABLE_CONTENT_PROPERTY,
  ],
  options: {
    stableColumnCount: 1,
    resizableHeaderColumn: true,
  },
};
